/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import {
    PiArrowBendRightDownThin, PiArrowUpRightThin,
    PiChartBarThin, PiClockThin, PiCoinsThin,
    PiFlagCheckeredThin,
    PiHeadphonesThin, PiHouseLineThin,
    PiMapTrifoldThin, PiShareNetworkThin,
} from "react-icons/pi";
import AppStatic from "../../../utils/AppStatic";

const AppAmbassadorBenefits = () => {
    return (
        <div className="relative mt-2 md:mt-4 md:mb-6">
            <div
                className="text-[#AAAAAA] text-lg flex gap-1 items-center text-center justify-center mt-10 mb-10 sm:mt-20 sm:mb-20">
                {AppStatic.mainAmbassadorBenefitsContinue.ro.translation}
                <PiArrowBendRightDownThin className="text-4xl"/>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full items-center justify-center">
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiMapTrifoldThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorFirstBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorFirstBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiCoinsThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorSecondBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorSecondBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiClockThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorThirdBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorThirdBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiChartBarThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorFourthBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorFourthBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiShareNetworkThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorFifthBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorFifthBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiHouseLineThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorSixthBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorSixthBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiArrowUpRightThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorSeventhBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorSeventhBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiHeadphonesThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorEighthBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorEighthBenefitText.ro.translation}
                    </p>
                </div>
                <div className="text-center pb-10 md:pb-20 text-[#EBE6DE]">
                    <PiFlagCheckeredThin className="text-6xl m-auto"/>
                    <p className="mt-2 uppercase text-2xl font-bold tracking-widest">
                        {AppStatic.mainAmbassadorNinthBenefitHeading.ro.translation}
                    </p>
                    <p className="text-[#AAAAAA] text-sm text-center px-0 sm:px-4 sm:min-h-[50px]">
                        {AppStatic.mainAmbassadorNinthBenefitText.ro.translation}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AppAmbassadorBenefits;
